import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '../../../../components/i18n/useTranslator';

// Components
import StyledButton from '../../../../components/buttons/StyledButton';

// Constants
import { MILANOTE_EMAILS } from '../../../../../common/notifications/notificationConstants';

const PromoBonus50FailureContent = ({ action }) => {
    const translate = useTranslator('modal', 'user.bonusCards.failure');

    return (
        <div className="modal-child-content">
            <img style={{ width: '32rem', height: '22.5rem' }} src={require('./promo-claim-failure.png')} />

            <div className="center-body">
                <h1>{translate('title', 'Something went wrong')}</h1>

                <p className="heavy">
                    {translate('description', "We weren't able to add bonus cards to your account")}
                </p>

                <br />
                <p className="help">
                    {translate('contactSupport', 'Need help? Contact')}{' '}
                    <a href={`mailto:${MILANOTE_EMAILS.SUPPORT}`}>{MILANOTE_EMAILS.SUPPORT}</a>
                </p>

                <StyledButton className="primary" onClick={action}>
                    {translate('returnButton', 'Return to Milanote')}
                </StyledButton>
            </div>
        </div>
    );
};

PromoBonus50FailureContent.propTypes = {
    action: PropTypes.func,
};

export default PromoBonus50FailureContent;
